export const getAccountLabel = (account: {
  accountCode?: string;
  accountName?: string;
}) => {
  return `${account.accountCode ? `${account.accountCode} - ` : ''}${
    account.accountName ?? ''
  }`;
};
